const EEStatementContent = `

[EE.—Statement under the simplified procedure for taxation of retail traders, etc., under Chapter XII-C

Form of statement to be furnished under section 115K.

11EE. [Omitted by the IT (Thirty-second Amdt.) Rules, 1999, w.e.f. 19-11-1999.]




`;

export default EEStatementContent;